export default "__VITE_ASSET__157bb26a__"